import { render, staticRenderFns } from "./SyntagePage.vue?vue&type=template&id=2ae5fc65&"
import script from "./SyntagePage.vue?vue&type=script&lang=js&"
export * from "./SyntagePage.vue?vue&type=script&lang=js&"
import style0 from "./SyntagePage.vue?vue&type=style&index=0&id=2ae5fc65&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports